import React from "react";
import PropTypes from "prop-types";
import {TextField as MuiTextField} from "@material-ui/core";

const TextField = props => {
    const {label, value, ...rest} = props;
    return (
        <MuiTextField
            label={label}
            value={value}
            readOnly
            fullWidth
            {...rest}
        />
    );
};

TextField.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
};

TextField.defaultProps = {
    value: '',
};

export default TextField;
